import * as authConstants from "../constants/authConstants";


import {
  sendErrorNotification,
  sendSuccessNotification,
} from "../../helpers/notifications";

const notificationMiddleware = () => (next) => (action) => {
  const { type, message } = action;
  switch (type) {
    case authConstants.LOGIN_FAILURE:
    case authConstants.REGISTER_FAILURE:
    case authConstants.LOGOUT_FAILURE:

      sendErrorNotification(message);
      break;
    /* case authConstants.LOGIN_SUCCESS:
    case authConstants.REGISTER_SUCCESS:
    case authConstants.LOGOUT_SUCCESS:
      sendSuccessNotification(message);
      break; */
    default:
      break;
  }
  return next(action);
};

export default notificationMiddleware;